import { inject, Signal } from '@angular/core';
import { AuthService } from '@app/core/services/auth/auth.service';

export const getIsClerk = (): Signal<boolean> => {
  const authService = inject(AuthService);

  return authService.isClerk;
};
